import api from '@/api'

const state = {
  locations: [],
  locationTypes: [],
  locationFile: {},
  locationById: {}
}

const getters = {
  locations: state => state.locations,
  locationTypes: state => state.locationTypes,
  locationFile: state => state.locationFile,
  locationById: state => state.locationById
}

const mutations = {
  SET_LOCATIONS(state, payload) {
    state.locations = payload
  },
  SET_LOCATION_TYPES(state, payload) {
    state.locationTypes = payload
  },
  SET_LOCATION_FILE(state, payload) {
    state.locationFile = payload
  },
  SET_LOCATION_BY_ID(state, payload) {
    state.locationById = payload
  }
}

const actions = {
  async fetchLocations({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getLocations(filter)

      if (data.error) {
        commit('SET_LOCATIONS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
      commit('SET_LOCATIONS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error
    }
  },
  async fetchLocationById({ commit }, id) {
    try {
      const { data } = await api.getLocationById(id)
      commit('SET_LOCATION_BY_ID', data)
    } catch (error) {
      throw error 
    }
  },
  async fetchLocationTypes({ commit }) {
    try {
      const { data } = await api.getLocationTypes()
      commit('SET_LOCATION_TYPES', data)
    } catch (error) {
      throw error
    }
  },
  async addLocation({}, payload) {
    try {
      await api.postLocations(payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async editLocation({}, payload) {
    try {
      await api.putLocations(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteLocation({}, id) {
    try {
      await api.deleteLocation(id)
    } catch ({ data }) {
      throw data
    }
  },
  async downloadLocations({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.exportLocation({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_LOCATION_FILE', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetLocationFile({ commit }) {
    commit('SET_LOCATION_FILE', {})
  },
  async fetchLocationsUnpaginated({ commit }, payload) {
    try {
      const { data } = await api.getLocations(payload)

      if (!data || data?.error) {
        commit('SET_LOCATIONS', [])
        return
      }

      commit('SET_LOCATIONS', data)
      return data
    } catch (error) {
      throw error
    }
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
